'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModelReducerEnhancer = undefined;

var _modelReducer2 = require('../reducers/model-reducer');

var _modelReducer3 = _interopRequireDefault(_modelReducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NULL_ACTION = { type: null };

function createModelReducerEnhancer() {
  var modelReducerCreator = arguments.length <= 0 || arguments[0] === undefined ? _modelReducer3.default : arguments[0];

  return function modelReducerEnhancer(reducer, model) {
    var initialState = void 0;
    try {
      initialState = reducer(undefined, NULL_ACTION);
    } catch (error) {
      initialState = null;
    }

    var _modelReducer = modelReducerCreator(model, initialState);

    return function () {
      var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
      var action = arguments[1];

      var updatedState = _modelReducer(state, action);

      return reducer(updatedState, action);
    };
  };
}

var modelReducerEnhancer = createModelReducerEnhancer(_modelReducer3.default);

exports.createModelReducerEnhancer = createModelReducerEnhancer;
exports.default = modelReducerEnhancer;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux-form/lib/enhancers/modeled-enhancer.js
 ** module id = 696
 ** module chunks = 0 1
 **/